import type { TableScene } from '@v2/contracts';

/** Every player has at most one card hand, regardless of card type or presentation. */
export function validateHandZones(scene: TableScene): void {
  const hands = new Map<string | undefined, string>();
  for (const zone of scene.zones) {
    if (zone.presentation === 'hand' && zone.role !== 'hand') throw new TypeError(`Held zone ${zone.id} must have the hand role`);
    if (zone.role !== 'hand') continue;
    const previous = hands.get(zone.owner);
    if (previous !== undefined) throw new TypeError(`Only one hand is allowed for ${zone.owner ?? 'unowned cards'}: ${previous} and ${zone.id}. Put all card types in the same hand zone.`);
    hands.set(zone.owner, zone.id);
  }
}
